import React from 'react';
import { Platform } from 'react-native';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { View, StyleSheet, TouchableOpacity, Animated } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';

import HomeScreen from '../centres/HomeScreenCentre';
import DocumentsScreen from '../centres/CreateContentScreen2';
import CentreScreen from '../centres/CentreScreenCentre';
import ProfileScreen from '../centres/ProfileScreenCentre';

const Tab = createBottomTabNavigator();

const CustomTabBar = ({ state, descriptors, navigation }) => {
  const animatedValues = React.useRef(
    state.routes.map(() => new Animated.Value(0))
  ).current;

  return (
    <View style={styles.container}>
      {state.routes.map((route, index) => {
        const { options } = descriptors[route.key];
        const isFocused = state.index === index;

        const onPress = () => {
          const event = navigation.emit({
            type: 'tabPress',
            target: route.key,
          });

          if (!isFocused && !event.defaultPrevented) {
            navigation.navigate(route.name);
          }

          Animated.sequence([
            Animated.timing(animatedValues[index], {
              toValue: 1,
              duration: 200,
              useNativeDriver: true,
            }),
            Animated.timing(animatedValues[index], {
              toValue: 0,
              duration: 200,
              useNativeDriver: true,
            }),
          ]).start();
        };

        const scale = animatedValues[index].interpolate({
          inputRange: [0, 0.5, 1],
          outputRange: [1, 1.2, 1],
        });

        let iconName;
        if (route.name === 'Accueil') iconName = 'home';
        else if (route.name === 'Documents') iconName = 'plus-circle';
        else if (route.name === 'Centres') iconName = 'file-document-edit';
        else if (route.name === 'Profil') iconName = 'account';

        return (
          <TouchableOpacity
            key={index}
            onPress={onPress}
            style={styles.tabButton}
            activeOpacity={0.7}
          >
            <Animated.View
              style={[
                styles.iconContainer,
                isFocused && styles.activeIconContainer,
                { transform: [{ scale }] },
              ]}
            >
              <MaterialCommunityIcons
                name={iconName}
                size={24}
                color={isFocused ? '#165ca2' : '#fff'}
              />
              {isFocused && <View style={styles.dot} />}
            </Animated.View>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

export default function Navigation() {
  // Sur le web, on n'utilise PAS la TabBar du bas : HomeScreenCentre a déjà
  // sa propre sidebar (CentreLayout) qui gère toute la navigation.
  if (Platform.OS === 'web') {
    return <HomeScreen />;
  }
  return (
    <Tab.Navigator
      tabBar={(props) => <CustomTabBar {...props} />}
      screenOptions={{
        headerShown: false,
      }}
    >
      <Tab.Screen name="Accueil" component={HomeScreen} />
      <Tab.Screen name="Centres" component={CentreScreen} />
      <Tab.Screen name="Profil" component={ProfileScreen} />
    </Tab.Navigator>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    position: 'absolute',
    bottom: 10,
    backgroundColor: '#165ca2',
    borderRadius: 25,
    marginHorizontal: 10,
    paddingVertical: 10,
    elevation: 10,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 5,
    },
    shadowOpacity: 0.15,
    shadowRadius: 10,
  },
  tabButton: {
    flex: 1,
    alignItems: 'center',
  },
  iconContainer: {
    padding: 10,
    borderRadius: 20,
    alignItems: 'center',
  },
  activeIconContainer: {
    backgroundColor: '#F2F0FC',
  },
  dot: {
    position: 'absolute',
    bottom: -5,
    width: 4,
    height: 4,
    borderRadius: 2,
    backgroundColor: '#F2F0FC',
  },
});